<template>
    <div class="page-title-area bg-22">
        <div class="container">
            <div class="page-title-content">
                <h2>Project Details</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Project Details</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>